
import config from '@/config/index'
import { getintegral } from '@/api/user.js'
import XInput from 'vux/src/components/x-input/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

import { getAddressDefault } from '@/api/user.js'
import { getDetail, addOrder } from '@/api/pintuan'
import addressedit from '@/views/address-select'
export default {
directives: {
TransferDom
},
components: { XInput, InlineXNumber, addressedit, Popup, Confirm },
data () {
return {
showTip: false,
openAddress: false,
baseUrl: config.baseUrl,
owner_type: config.owner_type,
productid: this.$route.params.id,
groupid: this.$route.params.groupid,
ordertype: parseInt(this.$route.params.type), // 1拼团;2|原价;
obj: {
ordertnum: 1,
ordercredit: '',
sendmethod: 1,
note: ''
},
creditTotal: '', // 总积分
addressObj: {},
proObj: {},
max: 1,
integral: 0,
shareaccountid: this.$route.query.shareaccountid || ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
mounted () {
this.getAddress()
this.getProDetail()
this.getintegralTotal()
},
watch: {
'obj.ordertnum' (val) {
this.creditTotal = this.obj.ordercredit * val
}
},
methods: {

getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue !== '') {
this.addressObj = res.returnValue
}
})
},

getProDetail () {
getDetail({
accountid: this.accountid,
id: this.productid
}).then(res => {
this.proObj = res.returnValue
if (this.proObj.limitcount >= this.proObj.canBuyCount) {
this.max = this.proObj.canBuyCount
} else {
this.max = this.proObj.limitcount
}
if (this.ordertype === 1) { // 拼团购买
this.obj.ordercredit = this.proObj.collectiveprice
} else if (this.ordertype === 2) { // 原价购买
this.obj.ordercredit = this.proObj.originalprice
}
this.creditTotal = this.obj.ordercredit * this.obj.ordertnum
})
},
changeAddress (isdisplay) {
if (isdisplay === 'false') {
this.openAddress = false
this.addressObj = this.$store.state.user.address
}
},

submit () {
let _this = this
if (JSON.stringify(this.addressObj) === '{}') {
this.$vux.toast.text('请选择收货地址', 'middle')
return false
}
addOrder({
productid: this.productid,
groupid: this.groupid,
accountid: this.accountid,
shareaccountid: this.shareaccountid,
ordertype: this.ordertype,
linkman: this.addressObj.NAME,
linkphone: this.addressObj.MOBILE,
linkaddress: this.addressObj.PROVINCEIDNAME + this.addressObj.CITYIDNAME + this.addressObj.COUNTYIDNAME + this.addressObj.ADDRESS,
...this.obj
}).then(res => {
if (res.status === 'suc') {
this.$vux.alert.show({
content: '提交成功',
onShow () {
_this.$router.push({ name: 'pintuanOrderList' })
}
})
}
})
},
getintegralTotal () {
/* 得到用户积分总信息 */
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue.allnow
})
}
}
}
